import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

/**
 * The reader's side of share subscriptions — the Following tab (`/investments/following`).
 */
export function createFollowingQueries(client: StoxlyClient) {
  return createQueryKeys('following', {
    // ['following', 'subscriptions'] — `GET /me/subscriptions`: the share links the reader follows
    // (each with its access and plan state) and the latest trades across them, already through
    // every link's privacy. Invalidate it after `public.subscribe` / `public.unsubscribe`.
    subscriptions: {
      queryKey: null,
      queryFn: ({ signal }) => client.followingGetSubscriptions({ signal }),
    },
  });
}
